import type { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { memoryBasePath } from "./FleetMemoryPage";
import { memoryPagePath, type CardMemoryRef } from "./card-memory";

/**
 * Torna qualquer card clicável para a sua memória de cálculo — que abre como
 * TELA própria (`/frota/memoria/:cardKey`), igual aos cards do Financeiro e do
 * Operacional. Sem `memory`, devolve o card como está (nada de clique que não
 * leva a lugar nenhum).
 */
export function CardMemoryTrigger({ memory, children, className }: {
  memory?: CardMemoryRef | null;
  children: ReactNode;
  className?: string;
}) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (!memory) return <>{children}</>;
  const abrir = () => navigate(memoryPagePath(memory, memoryBasePath(pathname)));
  return (
    <div
      role="link"
      tabIndex={0}
      title="Clique para ver a memória de cálculo"
      aria-label={`Memória de cálculo${memory.title ? `: ${memory.title}` : ""}`}
      onClick={abrir}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); abrir(); }
      }}
      className={`group relative cursor-pointer rounded-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-tm-400 ${className ?? ""}`}
    >
      {children}
      {/* Só no hover/foco: fixo, cobria o rodapé dos cards menores. */}
      <span className="pointer-events-none absolute bottom-2 right-2 rounded bg-white/95 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-tm-600 shadow-sm opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100">
        memória de cálculo ›
      </span>
    </div>
  );
}
